<div [class.inline]="displayInline">
<ng-container *ngIf="field.itype === 'text'">
	<textarea
		[(ngModel)]="modelValue"
		(ngModelChange)="onModelChange($event)"
		(change)="$event.stopPropagation();onChange(modelValue)"
		[name]="'custom-' + field.name"
		[theme]="theme"
		[ngClass]="cssClass"
	></textarea>
</ng-container>

<ng-container *ngIf="field.itype === 'objectEditor'">
	<bb-object-editor
		[(ngModel)]="modelValue"
		(ngModelChange)="onModelChange($event)"
		[name]="'custom-' + field.name"
		[theme]="theme"
		[ngClass]="cssClass"
	></bb-object-editor>
</ng-container>

<ng-container *ngIf="field.itype === 'align'">
	<mat-button-toggle-group
		[name]="'custom-' + field.name"
		[value]="modelValue"
		[(ngModel)]="modelValue"
		(ngModelChange)="onModelChange($event)"
	>
		<mat-button-toggle class="icon-center" value="left">
			<i class="fa fa-align-left"></i>
		</mat-button-toggle>
		<mat-button-toggle class="icon-center" value="center">
			<i class="fa fa-align-center"></i>
		</mat-button-toggle>
		<mat-button-toggle class="icon-center" value="right">
			<i class="fa fa-align-right"></i>
		</mat-button-toggle>
	</mat-button-toggle-group>
</ng-container>

<ng-container *ngIf="field.itype === 'verticalalign'">
	<mat-button-toggle-group
		[name]="'custom-' + field.name"
		[value]="modelValue"
		[(ngModel)]="modelValue"
		(ngModelChange)="onModelChange($event)"
	>
		<mat-button-toggle class="icon-center" value="top">
			<i class="fa fa-arrow-up-to-line"></i>
		</mat-button-toggle>
		<mat-button-toggle class="icon-center" value="center">
			<i class="fa fa-arrows-to-line"></i>
		</mat-button-toggle>
		<mat-button-toggle class="icon-center" value="bottom">
			<i class="fa fa-arrow-down-to-line"></i>
		</mat-button-toggle>
	</mat-button-toggle-group>
</ng-container>

<ng-container *ngIf="field.itype === 'togglebutton'">
	<mat-button-toggle
		[checked]="modelValue === true || modelValue === 'true'"
		(change)="onMatToggleChange($event.source.checked)"
	>
		<i *ngIf="field?.icon" class="fa fa-{{ field.icon }}"></i>
	</mat-button-toggle>
</ng-container>

<ng-container *ngIf="field.itype === 'checkbox' && field.type !== 'string'">
	<bb-check
		[(ngModel)]="modelValue"
		(ngModelChange)="onModelChange($event)"
		(change)="$event.stopPropagation();onChange(modelValue)"
		[name]="'custom-' + field.name"
		[theme]="theme ? theme + '-theme' : ''"
		[ngClass]="cssClass"
	></bb-check>
</ng-container>

<ng-container *ngIf="field.itype === 'checkbox' && field.type === 'string'">
	<bb-check
		[(ngModel)]="modelValue"
		(ngModelChange)="onModelChange($event)"
		[name]="'custom-' + field.name"
		[trueValue]="'true'"
		[falseValue]="'false'"
		[theme]="theme ? theme + '-theme' : ''"
		[ngClass]="cssClass"
	></bb-check>
</ng-container>

<ng-container *ngIf="field.itype === 'string'">
	<input
		type="text"
		[(ngModel)]="modelValue"
		(ngModelChange)="onModelChange($event)"
		(change)="$event.stopPropagation();onChange(modelValue)"
		[name]="'custom-' + field.name"
		[theme]="theme"
		[ngClass]="cssClass"
	/>
</ng-container>

<ng-container *ngIf="field.itype === 'number'">
	<input
		type="number"
		[(ngModel)]="modelValue"
		(ngModelChange)="onModelChange($event)"
		(change)="$event.stopPropagation();onChange(modelValue)"
		[name]="'custom-' + field.name"
		[theme]="theme"
		[ngClass]="cssClass"
	/>
</ng-container>

<ng-container *ngIf="field.itype === 'font'">
	<bb-entity-selector 
		[(ngModel)]="modelValue"
		(ngModelChange)="onModelChange($event)"
		(optionSelected)="onFontOptionSelected($event)"
		[name]="'custom-' + field.name"
		[valueProp]="field.valueProp"
		[labelProp]="field.labelProp"
		[disableClear]="true"
		[extraOptions]="field.extraOptions"
		[filterSet]="[{
			filters: [{
				type: 'mediaclip',
				field: 'mediatype',
				operator: 'is',
				value: 'font'
			}]
		}, {
			filters: [{
				type: 'mediaclip',
				field: 'originalfilename',
				operator: 'doesNotContain',
				value: '.svg'
			}]
		}]"
		[entityType]="'creative'"
		[theme]="theme"
		[ngClass]="cssClass"
	></bb-entity-selector>
</ng-container>

<ng-container *ngIf="field.itype === 'relation' || field.itype === 'relationlist'">
	<bb-entity-selector 
		[(ngModel)]="modelValue"
		(ngModelChange)="onModelChange($event)"
		[name]="'custom-' + field.name"
		[valueProp]="field.valueProp"
		[labelProp]="field.labelProp"
		[entityType]="field.contenttype === 'mediacliplist' ? 'cliplist' : field.contenttype"
		[multi]="field.itype === 'relationlist'"
		[theme]="theme"
		[ngClass]="cssClass"
	></bb-entity-selector>
</ng-container>

<ng-container *ngIf="field.itype === 'list' && !field.extendable">
	<bb-entity-selector 
		[(ngModel)]="modelValue"
		(ngModelChange)="onModelChange($event)"
		[name]="'custom-' + field.name"
		[multi]="field.type === 'multistring'"
		[options]="field.options"
		[theme]="theme"
		[ngClass]="cssClass"
	></bb-entity-selector>
</ng-container>

<ng-container *ngIf="field.itype === 'list' && field.extendable">
	<bb-entity-selector 
		[(ngModel)]="modelValue"
		(ngModelChange)="onModelChange($event)"
		[name]="'custom-' + field.name"
		[multi]="field.type === 'multistring'"
		[extendable]="true"
		[entityType]="'mediaclip'"
		[facet]="field.name"
		[theme]="theme"
		[ngClass]="cssClass"
	></bb-entity-selector>
</ng-container>

<ng-container *ngIf="field.itype === 'date'">
	<bb-datepicker 
		[(ngModel)]="dateString"
		(ngModelChange)="onDateChange($event)"
		[initialDate]="dateString"
		[name]="'custom-' + field.name"
		[theme]="theme"
		[ngClass]="cssClass"
	></bb-datepicker>
</ng-container>

<ng-container *ngIf="field.itype === 'color'">
	<bb-color-picker-box
		[(ngModel)]="modelValue"
		[name]="'custom-' + field.name"
		(ngModelChange)="onModelChange($event)"
		[excludeHexHash]="theme === 'dark'"
		[disableClear]="theme === 'dark'"
		[theme]="theme"
		[useOverlay]="theme === 'dark'"
		[ngClass]="cssClass"
		[pickerPosition]="theme === 'dark' ? 'left' : undefined"
	></bb-color-picker-box>
</ng-container>

<ng-container *ngIf="field.itype === 'richtext'">
	<bb-wysiwyg
		[(ngModel)]="modelValue"
		(ngModelChange)="onModelChange($event)"
		[name]="'custom-' + field.name"
		[theme]="theme"
		[ngClass]="cssClass"
	></bb-wysiwyg>
</ng-container>
</div>

<ng-container *ngIf="field.itype === 'pillbox'">
	<bb-pillbox 
		[config]="pillboxConfig"
		(onChangeProperty)="onModelChange($event)">
	</bb-pillbox>
</ng-container>
